import SignUpForm from './SignUpForm';
import Testimony from './Testimony';
import useText from '@/hooks/useText';
import BackgroundPages from '@/global/Background/BackgroundPages';
import SharedBadge from '@/global/Badge/Badge';

function ApplyTrial() {
  const testimonialsLabel = useText('home.testimonials.label');
  const testimonialsTitle = useText('home.testimonials.title');
  const eyebrow = useText('signup.apply_trial.label');
  const title = useText('signup.apply_trial.title');
  const titleHighlight = useText('signup.apply_trial.title_highlight');
  const titleSuffix = useText('signup.apply_trial.title_suffix');
  const subtitle = useText('signup.apply_trial.subtitle');
  const subtitleHighlight = useText('signup.apply_trial.subtitle_highlight');

  return (
    <>
      <BackgroundPages />
      <div className="apply-trial-content mt-14">
        <div className="home-hero-content">
          <div className="home-hero-section">
            <SharedBadge text={eyebrow} icon={null} variant="primary" size="sm" />
            <h1 className="w-3/4 text-center mx-auto font-semibold">
              {title} <span className="home-hero-highlight">{titleHighlight}</span> {titleSuffix}
            </h1>
            <p className="w-3/4 text-center mx-auto text-md font-medium">
              {subtitle}
              <strong>{subtitleHighlight}</strong>.
            </p>
            <div className="w-full flex justify-center">
              <SignUpForm />
            </div>
          </div>
        </div>
        <section id="testimonials" className="home-section home-section-dark home-testimonials">
          <div className="text-center">
            <span className="home-section-label text-pink mb-4">{testimonialsLabel}</span>
            <h2 className="home-section-title home-section-title-center home-section-title-light text-white">
              {testimonialsTitle}
            </h2>
          </div>
          <Testimony variant="cards" />
        </section>
      </div>
    </>
  );
}

export default ApplyTrial;
